module.exports = __webpack_public_path__ + "static/media/empty.bb223198.png";